import { FC } from 'react';
import { Button, DropdownMenu, Icon } from '@pwc/pwc-deals-ui';
import { useSelector } from 'react-redux';
import { getFakeClientUser } from 'common/redux/security/loggedInUser/loggedInUserSlice';
import { COMMENT_VIEWING_STATUS } from '../../../features/comments/constants';

type Props = {
  commentPanelOpened: boolean;
  totalComments: number;
  totalCommentsUnresolved: number;
  hasCommentSelection: boolean;
  isProjectDisabled: boolean;
  handleResolveClick: () => void;
  handleResolveAllClick: () => void;
  viewingStatus: 'unresolved' | 'resolved';
};

const CommentPanelActions: FC<Props> = ({
  commentPanelOpened,
  hasCommentSelection,
  isProjectDisabled,
  totalComments,
  totalCommentsUnresolved,
  handleResolveClick,
  handleResolveAllClick,
  viewingStatus,
}) => {
  const isFakeClient = useSelector(getFakeClientUser);

  const optionsItems = [
    {
      text:
        viewingStatus === COMMENT_VIEWING_STATUS.UNRESOLVED
          ? 'Show resolved'
          : 'Hide resolved',
      icon: <Icon name="view" width="24" />,
      iconClassName: 'outline icon-orange-theme',
      disabled: totalComments === 0 || isProjectDisabled,
      onClick: handleResolveClick,
    },
    {
      text: 'Resolve all',
      icon: <Icon name="confirmed" width="24" />,
      iconClassName: 'outline icon-orange-theme',
      disabled: totalCommentsUnresolved === 0 || isProjectDisabled,
      onClick: handleResolveAllClick,
    },
  ];

  const isDisabled = hasCommentSelection || isProjectDisabled;

  return (
    <div className="comment-panel-actions">
      {!isFakeClient ? (
        <div
          className="comment-panel-actions__add-comment"
          hidden={!commentPanelOpened}
        >
          <Button
            className="new-comment-button button-link"
            iconClasses="outline icon-orange-theme"
            data-testid="new-comment-button"
            icon="comment-plus"
            disabled={isDisabled}
          >
            Add comment
          </Button>
        </div>
      ) : null}
      {commentPanelOpened && (
        <div className="comment-panel-actions__options">
          <DropdownMenu title="Options" items={optionsItems} />
        </div>
      )}
    </div>
  );
};

export default CommentPanelActions;
